import React from "react";

import { BettingOfferStatus } from "@api-types/offer/offer-history/BettingOfferStatus";

export default function EventHistoryStatusIcon(props: { status: number }) {
	switch (props.status) {
		case BettingOfferStatus.Win:
			return (
				<i className="u-icon u-icon--sml u-icon--check-circle--bold u-color--sent--success" />
			);
		case BettingOfferStatus.Cancelled:
		case BettingOfferStatus.Refund:
			return (
				<i className="u-icon u-icon--sml u-icon--refresh u-color--sent-warning" />
			);
		case BettingOfferStatus.Lose:
			return <span className="quote--loss">-</span>;
		default:
			return <>INACTIVE</>;
	}
}
